/* global toastr */

import { wrapView, request } from '../smart_bps/lib/utils'
import { stateToProps } from '../smart_bps/bps/base_view'
import { PROJECT_NAME } from './constants'
import { SigurListView } from '../lib/SigurListView'
import { AccessObjectsUploadModal } from './AccessObjectsUploadModal'
import { AccessObjectsActivateModal } from './AccessObjectsActivateModal'
import { AccessObjectsModalSearch } from './AccessObjectsModalSearch'
import { SigurModalOrderColumn } from '../common_components/modal_order_column'
import {store} from "../index";

const STATE_FILTERS = [
  { value: '', label: 'Все' },
  { value: 'draft', label: 'Черновик' },
  { value: 'active', label: 'Действующий' },
  { value: 'archive', label: 'Недействующий' },
  { value: 'in_blacklist', label: 'В черном списке' },
]

class ListView extends SigurListView {
  constructor(props) {
    super(props)
    this.state = {
      ...this.state,
      showBlacklistHistoryForAoId: null,
      stateCounters: {},
    }

    this.loadStateCounters = this.loadStateCounters.bind(this)
    this.openBlacklistHistoryForAo = this.openBlacklistHistoryForAo.bind(this)
    this.openBlacklistHistoryForAo = this.openBlacklistHistoryForAo.bind(this)
    this.closeBlacklistHistoryForAo = this.closeBlacklistHistoryForAo.bind(this)
  }

  getTopPanelLeftactions() {
    const actions = super.getTopPanelLeftactions()
    actions.push(
      <li key="upload">
        <a className="dropdown-item" data-bs-toggle="modal" data-bs-target="#modal_upload_access_objects">
          <i className="ti ti-upload ti-xs me-1"></i>
          <span className="d-none d-md-inline-block">Массовая загрузка</span>
        </a>
      </li>
    )
    actions.push(
      <li key="activate_drafts">
        <a className="dropdown-item" data-bs-toggle="modal" data-bs-target="#modal_activate_access_objects">
          <i className="ti ti-arrows-transfer-up ti-xs me-1"></i>
          <span className="d-none d-md-inline-block">Перевести на этап Действующий</span>
        </a>
      </li>
    )
    return actions
  }
  renderModals() {
    return [
      <SigurModalOrderColumn project_name={this.project_name}
      attrs={this.props.attrs}
      table_headers={this.props.table_headers}
      user_table_headers={this.props.user_table_headers} />
      ,
      <AccessObjectsUploadModal
        key="upload"
        project_name={this.project_name}
        onUploadSuccess={() => this.updateItems(this.props.list_page)}
      />,
      <AccessObjectsActivateModal
        key="activate_drafts"
        project_name={this.project_name}
        onApplySuccess={() => this.updateItems(this.props.list_page)}
      />,
      <AccessObjectsModalSearch
        key="search"
        project_name={this.project_name}
        schema={this.props.search_form}
        data={this.props.search_data}
        onSearch={this.onSearch}
        choices={this.props.choices}
      />,
      this.renderBlacklistHistoryModalForRequest(),
      ...(super.renderModals() || [])
    ]
  }

  openBlacklistHistoryForAo(accessObjectId) {
    this.setState({ showBlacklistHistoryForAoId: accessObjectId, blacklistHistoryItems: null })
    const that = this
    request({
      method: 'get',
      url: `/api/access_objects/${accessObjectId}/blacklist_history`,
      success: (data) => {
        that.setState({ blacklistHistoryItems: data.items || [] })
      },
      error: () => {
        that.setState({ blacklistHistoryItems: [] })
        toastr.error('Не удалось загрузить историю')
      },
    })
  }

  closeBlacklistHistoryForAo() {
    this.setState({ showBlacklistHistoryForAoId: null })
  }

  setStageFilter(value) {
    store.dispatch({ type: `${this.project_name}_preset`, data: value })
    store.dispatch({ type: `${this.project_name}_list_clean` })
    this.setState({ preset_counters: {} })
  }

  componentDidMount() {
    this.loadStateCounters()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.user !== this.props.user) {
      this.applyDefaultStateFilter()
    }

    if (prevProps.search_data !== this.props.search_data) {
      this.loadStateCounters()
    }
  }

  applyDefaultStateFilter() {
    if (this.defaultStateApplied) return
    const roles = Array.isArray(this.props.user?.roles) ? this.props.user.roles : []
    if (roles.length === 0) return

    let defaultState = ''

    this.defaultStateApplied = true
    this.setStageFilter(defaultState)
  }

  loadStateCounters() {
    const current = this.props.search_data || {}
    const { state: _state, ...baseFilterData } = current

    STATE_FILTERS.forEach(({ value }) => {
      const key = value || '__all__'

      const filter_data = value ? { ...baseFilterData, state: value } : baseFilterData
      request({
        method: 'post',
        url: `/api/${this.project_name}/get_preset_counter`,
        data: {
          filter_data,
          preset: value,
        },
        success: (count) => {
          this.setState((prev) => ({
            stateCounters: { ...prev.stateCounters, [key]: count || 0 },
          }))
        },
      })
    })
  }

  renderBlacklistHistoryModalForRequest() {
    if (!this.state.showBlacklistHistoryForAoId) return null
    const items = this.state.blacklistHistoryItems || []
    const formatDate = (iso) => {
      if (!iso) return '—'
      try {
        const d = new Date(iso)
        return d.toLocaleString('ru-RU', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })
      } catch (e) {
        return iso
      }
    }
    return (
      <div className="modal show d-block" tabIndex="-1" style={{ background: 'rgba(0,0,0,0.5)' }}>
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">История изменений (черный список)</h5>
              <button type="button" className="btn-close" onClick={this.closeBlacklistHistoryForAo} aria-label="Закрыть" />
            </div>
            <div className="modal-body">
              <table className="table table-sm">
                <thead>
                  <tr>
                    <th>В черном списке</th>
                    <th>Дата события</th>
                    <th>Причина</th>
                  </tr>
                </thead>
                <tbody>
                  {items.length === 0 && (
                    <tr><td colSpan={3} className="text-muted">Нет записей</td></tr>
                  )}
                  {items.map((row, idx) => (
                    <tr key={idx}>
                      <td>{row.in_blacklist_display || (row.in_blacklist ? 'Да' : 'Нет')}</td>
                      <td>{formatDate(row.d_event)}</td>
                      <td>{row.reason || '—'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" onClick={this.closeBlacklistHistoryForAo}>Закрыть</button>
            </div>
          </div>
        </div>
      </div>
    )
  }

  renderTrTd(row, attr_name, idx) {
    if (attr_name === "blacklist" && row[attr_name] === "Да") {
      const attr = this.props.attrs[attr_name]

      const content = <span
        role="button"
        tabIndex={0}
        className="sigur-cell-link"
        onClick={() => this.openBlacklistHistoryForAo(row.id)}
        onKeyDown={(e) => e.key === 'Enter' && this.openBlacklistHistoryForAo(row.id)}
      >
        Да
      </span>
      return <td key={attr_name}>{content}</td>
    } else {
      return super.renderTrTd(row, attr_name, idx)
    }
  }

  renderContent() {
    const currentPreset = this.props.search_preset || ''
    const stateCounters = this.state.stateCounters || {}
    const chips = (
      <div className="card mb-3">
        <div className="card-body py-2">
          <span className="me-2 text-muted small">Этап:</span>
          {STATE_FILTERS.map(({ value, label }) => (
            <button
              key={value}
              type="button"
              className={`btn btn-sm me-1 ${currentPreset === value ? 'btn-primary' : 'btn-outline-secondary'}`}
              onClick={() => this.setStageFilter(value)}
            >
              {label} ({stateCounters[value || '__all__'] ?? 0})
            </button>
          ))}
        </div>
      </div>
    )
    const content = super.renderContent()
    return [chips, ...(Array.isArray(content) ? content : [content])]
  }
}

export default wrapView(ListView, (state) => {
  return stateToProps(state, PROJECT_NAME)
})
